
import React, { useEffect, useState } from "react";
import './home.css'
import { Link } from 'react-router-dom';

const Home = () => {

   const [loading, setLoading] = useState(true);
      
        useEffect(() => {
          const timer = setTimeout(() => {
            setLoading(false);
          }, 400);
      
          return () => clearTimeout(timer); // Cleanup on unmount
        }, []);
      
        if (loading) {
          return (
            <div
              id="spinner"
              className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
              style={{ zIndex: 9999 }}
            >
              <div
                className="spinner-border text-primary"
                style={{ width: "3rem", height: "3rem" }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>{" "}
                {/* Updated from sr-only */}
              </div>
            </div>
          );
        }
  return (
    
    <div className='main'>
      
      
      <div className="homepage" style={{ backgroundImage: `url('./Vella.jpg')` }}>


      {/* Navigation Bar */}

      <header className="navbar">
      <div className="logo">Asset Management System</div>
      

      <nav>
        <ul className="nav-links">
          <li>
            <Link to="/about">About Us</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
          <li>
            <Link to="/Login">Login</Link>
          </li>
        </ul>
      </nav>
    </header>

       {/* Hero Section */}
       <section className="hero">
        <div className="hero-content">
          <h1>Manage Your Assets Efficiently</h1>
          <p>Track, organize, and manage your assets with ease.</p>
          
        </div>
      </section>
{/* Features Section */}
<section id="features" className="features">
  <h2>Our Features </h2>
  <div className="feature-cards">
    <div className="feature-card">
      <img src="/home1.jpg" alt="Asset Tracking" className="feature-icon" />
      <h3>Asset Register</h3>
      <p>Keep track of all assets in one place.</p>
    </div>
    <div className="feature-card">
      <img src="/home5.jpg" alt="Asset Transfer" className="feature-icon" />
      <h3>AssetTransfer</h3>
      <p>Easily transfer asset.</p>
    </div>
    <div className="feature-card">
      <img src="/home3.jpg" alt="Real-time Dashboard" className="feature-icon" />
      <h3>Real-time Dashboard</h3>
      <p>View key metrics and insights instantly.</p>
    </div>
  </div>
</section>

      {/* Footer */}
      {/*<footer className="footer">
        <p>© 2025 Asset Management System. All rights reserved.Designed and Developed by Vella Team IT</p>
      </footer>*/}

      <footer className="footer">
  <div className="footer-container">
    
    {/* Left Side */}
    <div className="footer-left">
      <h3><span className="vella">VELLA</span> GROUP OF COMPANIES</h3>
    </div>

    {/* Center Social Icons */}
    <div className="footer-center">
      <a href="https://www.facebook.com/vellagroupofcompanies"><i className="fab fa-facebook-f"></i></a>
      <a href="https://www.vellaglobal.com/"><i className="fas fa-globe"></i></a>
      <a href="https://www.linkedin.com/company/vellaholdings/?viewAsMember=true"><i className="fab fa-linkedin-in"></i></a>
    </div>

    {/* Right Side */}
    <div className="footer-right">
      <p>
        © 2026 Asset Management System. All Rights Reserved.
        Designed and Developed by <span className="team">Vella Team IT</span>
      </p>
    </div>

  </div>
</footer>
    </div>
    </div>
    
  )
}

export default Home
